import React, { Component } from 'react';

import moment from 'moment';

import { getUnverifiedUsers } from '../../services/apiService';
import VerifyUser from './VerifyUser';
import RenderProfilePic from '../../extras/RenderProfilePic';
import { getFullName } from '../../utils';
import { connect } from 'react-redux';
import * as verificationActions from '../../redux/actions/profileVerificationActions';
import { toast } from 'react-toastify';
import { PageHeader } from '../../extras/PageLayout';
class ExpertiseVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  loadUnverifiedUsers = async () => {
    try {
      const response = await getUnverifiedUsers();
      this.setState({ users: response });
    } catch {
      toast.error('Error fetching unverified users');
    }
  };

  componentDidMount = () => {
    this.loadUnverifiedUsers();
  };

  componentDidUpdate(prevProps) {
    if (this.props.user !== prevProps.user && this.props.user === null) {
      this.loadUnverifiedUsers();
    }
  }

  render = () => {
    if (this.props.user) return <VerifyUser user={this.props.user} />;

    return (
      <div>
        <PageHeader
          title="Profile Verification"
          subtitle="Verify and manage user profiles"
        />

        {/* filter options */}
        <div className='flex gap-4 items-center mt-8 mb-4 ml-2'>
          <div
            onClick={() => this.setState({ filterBy: null })}
            className={
              !this.state.filterBy ? 'text-blue-500' : 'cursor-pointer'
            }
          >
            All ({this.state.users.length})
          </div>

          {/* to push next element to extreme right */}
          <div className='flex-grow' />

          <div className='bg-white border border-gray-300 rounded mr-2 p-2'>
            <select
              onChange={({ target }) =>
                this.setState({ filterByStatus: target.value })
              }
              value={this.state.filterByStatus || ''}
              className='cursor-pointer focus:outline-none'
            >
              <option value=''>Status</option>
              <option value='hold'>Hold</option>
              <option value='new'>New</option>
            </select>
          </div>
        </div>

        {/* Users list */}
        <div className='overflow-x-auto bg-white border border-gray-300 rounded-md overflow-hidden'>
          <table className='w-full table-auto text-center divide-y divide-gray-300'>
            <thead className='text-gray-400'>
              <tr>
                <td className='py-3 px-4 text-left'>Name</td>
                <td className='py-3 px-4'>UserID</td>
                <td className='py-3 px-4'>Reg Date</td>
                <td className='py-3 px-4'>Designation</td>
                <td className='py-3 px-4'>Status</td>
                <td className='py-3 px-4'>Action</td>
              </tr>
            </thead>

            <tbody className='divide-y divide-gray-300'>
              {this.state.users.map((user) => (
                <tr key={user.id}>
                  <td className='py-2 px-4 whitespace-nowrap text-left flex items-center gap-4'>
                    <RenderProfilePic
                      thumbnail={user.thumbnail}
                      name={user.firstName}
                      size={3}
                    />
                    <span>{getFullName(user)}</span>
                  </td>
                  <td className='py-2 px-4 text-sm'>{user.id}</td>
                  <td className='py-2 px-4'>
                    {moment(user.createdOn).utc().format('DD/MM/YYYY')}
                    <span className='text-gray-400 ml-2'>
                      ({moment(user.createdOn).utc().fromNow()})
                    </span>
                  </td>
                  <td className='py-2 px-4'>{user.sentFrom}</td>
                  <td className='text-white text-sm'>
                    {user.status === 'hold' ? (
                      <span className='bg-red-600 py-1 px-4 rounded'>Hold</span>
                    ) : (
                      <span className='bg-yellow-500 py-1 px-4 rounded'>
                        New
                      </span>
                    )}
                  </td>
                  <td
                    onClick={() => this.props.setProfileToVerify(user)}
                    className='py-2 px-4 cursor-pointer'
                  >
                    <i className='fas fa-arrow-right' />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => state.profileVerificationReducer;

export default connect(
  mapStateToProps,
  verificationActions
)(ExpertiseVerification);
